module.exports = __webpack_public_path__ + "static/img/psi_logo.062898c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/psi_logo.svg
// module id = 89NM
// module chunks = 1